export default __webpack_public_path__ + "static/media/binoculars.5bd8a5b5.svg";